import { render, staticRenderFns } from "./PlatformDefinitionForm.vue?vue&type=template&id=7d44cba4"
import script from "./PlatformDefinitionForm.vue?vue&type=script&lang=js"
export * from "./PlatformDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./PlatformDefinitionForm.vue?vue&type=style&index=0&id=7d44cba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports